import type { PivotValueComparison } from '@ztechapps/common.contract'
import { PivotFieldTypeEnum } from '@ztechapps/common.contract'
import { applyConditionFilter } from './applyConditionFilter'

/**
 * Whether a member's aggregated value passes a Value comparison. It compares as a Number Condition does: by value,
 * `between` includes both bounds and `not_between` keeps only a value strictly outside them; a member without a
 * value never passes, whatever the operator.
 */
export const applyValueComparison = ({
  comparison,
  value,
}: {
  comparison: PivotValueComparison
  value: number | undefined
}): boolean =>
  value !== undefined &&
  applyConditionFilter({
    condition: comparison,
    memberKey: String(value),
    fieldType: PivotFieldTypeEnum.Number,
    // a comparison never holds a relative operator, the only reader of the day
    today: '',
  })
